import React from "react";
import { ContainerProps } from "@mui/material";
import { StyledContainer } from "./styles";

export type PpContainer = ContainerProps;

export function Container(props: PpContainer): React.ReactElement {
  return <StyledContainer maxWidth="lg" {...props} />;
}
